import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { get } from '../../../core/client';

export const getUserInfo: any = createAsyncThunk('user/userInfo', async () => {
    const userData = await get<any>('users/user-profile-info-light');
    return userData;
});

export const getUserClaims: any = createAsyncThunk('user/userClaims', async () => {
    const userClaims = await get<any>(`/users/claims`);
    return userClaims;
});

export const getUserKvkk: any = createAsyncThunk('user/userKvkk', async () => {
    const userKvkk = await get<any>(`/kvkk/get-kvkk?appId=1`);
    return userKvkk;
});

const usersSlice = createSlice({
    name: 'users',
    initialState: {
        info: {
            userInfo: null,
            userLoading: true,
        },
        myUserInfo: {
            token: '',
        },
        newUserInfo: {
            token: '',
        },
        userClaims: {
            loading: true,
            items: [],
        },
        Kvkk: {
            loading: true,
            items: [],
        },
    },
    reducers: {
        setMyUserInfo(state) {
            const REFRESH_TOKEN = JSON.parse(localStorage.getItem('REFRESH_TOKEN'))
            state.myUserInfo.token = REFRESH_TOKEN;
        },
        setNewUserInfo(state,action) {
            state.newUserInfo.token = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(getUserInfo.fulfilled, (state, action: PayloadAction<any>) => {
            state.info.userInfo = action.payload.isSuccessful ? action.payload.result : null;
            state.info.userLoading = false;
        });
        builder.addCase(getUserClaims.fulfilled, (state, action: PayloadAction<any>) => {
            state.userClaims.items = action.payload.result.items
        });
        builder.addCase(getUserKvkk.fulfilled, (state, action: PayloadAction<any>) => {
            state.Kvkk.items = action.payload.result
        });
    },
    
});
export const { setMyUserInfo,setNewUserInfo } = usersSlice.actions;

export default usersSlice.reducer;
